/* eslint-disable i18next/no-literal-string */

import basePosthog from 'posthog-js'
import {
  PostHogProvider as BasePosthogProvider,
  usePostHog as useBasePostHog,
} from 'posthog-js/react'
import { type PropsWithChildren } from 'react'
import { env } from '~/env'

export const posthog = basePosthog.init(env.EXPO_PUBLIC_POSTHOG_KEY, {
  api_host: 'https://eu.i.posthog.com',
  person_profiles: 'always',
  capture_pageview: false,
  capture_pageleave: true,
  capture_exceptions: true,
  capture_dead_clicks: true,
  capture_heatmaps: true,
  capture_performance: true,
})

export function PostHogProvider({ children }: PropsWithChildren) {
  return <BasePosthogProvider client={posthog}>{children}</BasePosthogProvider>
}

export function usePostHog() {
  return useBasePostHog()
}
